module.exports = __webpack_public_path__ + "media/images/lp_consultation/common-flow-device-small-61c1e1fb0701aead89b3194420fb4efb.png";